import { Box, Stack } from '@mui/material';
import { StyleObj } from '../../../../@types';
import { EventsCarouselProps } from '../../../molecules/EventsCarousel';
import EventCard from './EventCard';
import Heading from './Heading';

const styles: StyleObj = {
  container: {
    borderTop: '1px solid',
    borderColor: 'info.600',
  },
  row: {
    overflowX: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    backgroundColor: 'neutral.600',
  },
  card: {
    flexShrink: 0,
    width: 200,
    borderRight: 1,
    borderColor: 'primary.main',
  },
};

const EventsCarousel = ({ title, events, topMarketTypes, link }: EventsCarouselProps) => {
  return (
    <Box sx={styles.container}>
      <Heading to={link}>{title}</Heading>
      <Stack sx={styles.row} direction='row'>
        {events.map((event) => (
          <Box key={event.id} sx={styles.card}>
            <EventCard event={event} topMarketTypes={topMarketTypes} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default EventsCarousel;
